<template>
  <a @click="handleTwitterShare" class="img-a-button">
    <img src="@/assets/btn-twitter.png" alt="Share on twitter" />
  </a>
</template>

<script>
// Docs: https://developer.twitter.com/en/docs/twitter-for-websites/tweet-button/overview.html
import { popupAtCenter } from "@/utils.js";
import { trackEvent } from "@/analytics";
const twitterStatuses = [
  "A problem that keeps growing just a little every time it moves. Is this a good enough metaphor for Brexit, Twitter? Give it a try here",
  "Now playing Snake, a retro sensation remade as a web browser game from @Covve. Did we mention (pun intended) that there's an Alexa Echo Plus for high scores?",
  "Play Covve Snake with your friends and win!",
  "I scored #{score} on Snake - think you can beat me?"
];

const buildTwitterStatus = (score, statuses) => {
  const status = statuses[Math.floor(Math.random() * statuses.length)];
  return status.replace("#{score}", score);
};

export default {
  props: ["currentUser", "score", "referralUrl"],
  methods: {
    handleTwitterShare() {
      trackEvent("shared");
      const status = buildTwitterStatus(this.score, twitterStatuses);
      const shareUrl = `https://twitter.com/intent/tweet?url=${this.referralUrl}&text=${status}&hashtags=covve,snake,snakegame,nowplaying`;
      console.log(shareUrl);
      popupAtCenter(shareUrl, "Tweet your score", 600, 400);
    }
  }
};
</script>

